__turbopack_context__.v({
  "avatar": "_4jeW3G_avatar",
  "body": "_4jeW3G_body",
  "commentBtn": "_4jeW3G_commentBtn",
  "commentBtnDisabled": "_4jeW3G_commentBtnDisabled",
  "composer": "_4jeW3G_composer",
  "composerEditor": "_4jeW3G_composerEditor",
  "composerLoading": "_4jeW3G_composerLoading",
  "deleteBtn": "_4jeW3G_deleteBtn",
  "deleteCancelBtn": "_4jeW3G_deleteCancelBtn",
  "deleteConfirm": "_4jeW3G_deleteConfirm",
  "deleteConfirmBtn": "_4jeW3G_deleteConfirmBtn",
  "empty": "_4jeW3G_empty",
  "error": "_4jeW3G_error",
  "feedCommentHighlightPulse": "_4jeW3G_feedCommentHighlightPulse",
  "forumLink": "_4jeW3G_forumLink",
  "head": "_4jeW3G_head",
  "heading": "_4jeW3G_heading",
  "inline": "_4jeW3G_inline",
  "item": "_4jeW3G_item",
  "itemPending": "_4jeW3G_itemPending",
  "list": "_4jeW3G_list",
  "name": "_4jeW3G_name",
  "primaryBtn": "_4jeW3G_primaryBtn",
  "repliesWrapper": "_4jeW3G_repliesWrapper",
  "replyBtn": "_4jeW3G_replyBtn",
  "replyCancelBtn": "_4jeW3G_replyCancelBtn",
  "replyComposer": "_4jeW3G_replyComposer",
  "retryBtn": "_4jeW3G_retryBtn",
  "richText": "_4jeW3G_richText",
  "role": "_4jeW3G_role",
  "signInBtn": "_4jeW3G_signInBtn",
  "signedOut": "_4jeW3G_signedOut",
  "skeletonPulse": "_4jeW3G_skeletonPulse",
  "skeletonRow": "_4jeW3G_skeletonRow",
  "text": "_4jeW3G_text",
  "textAttachment": "_4jeW3G_textAttachment",
  "thread": "_4jeW3G_thread",
  "threadCard": "_4jeW3G_threadCard",
  "time": "_4jeW3G_time",
  "viewAll": "_4jeW3G_viewAll",
});
